export default __webpack_public_path__ + "static/media/US_Hero6_2.c8717d47.png";